export default "__VITE_ASSET__BUp2t_oB__"